import { get } from 'lodash'
import { StaticPages } from '@/types/user'
const requireContext = require.context('./', false, /\.html$/)

export default requireContext.keys()
  .reduce(
    (acc, i) => {
      const key = get(i.match(/\w+/i), [0], null)
      return key
        ? {
          ...acc,
          [key]: requireContext(i).default
        }
        : acc
    },
    {} as Record<StaticPages, string>
  )
